import Form from '../_form';

const [ REDIRECTION_TIMEOUT, REDIRECTION_PATH ] = [ 3000, window.location.origin ];

export default class SignInForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const nonce = formData.get('sign_in_nonce');

        const email = formData.get('email');
        const password = formData.get('password');
        const remember = formData.get('remember');

        try {
            await fetch('/wp-json/auth/v1/sign-in', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ nonce, email, password, remember })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.NotificationManager.sendNotification('success', 'Successfully signed in!', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    setTimeout(() => window.location.href = REDIRECTION_PATH, REDIRECTION_TIMEOUT);
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');
        }
    }
}
